import { ArrowRight, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import WalkKitBuilder from "./WalkKitBuilder";
import { BUNDLE, money } from "../lib/data";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

export const useAddBundle = () => {
  const { add } = useCart();
  return () => {
    add({
      slug: BUNDLE.slug,
      name: BUNDLE.name,
      price: BUNDLE.price,
      currency: BUNDLE.currency,
      image: BUNDLE.images[2],
      qty: 1,
      options: { kit: true },
      optionsLabel: "Harness + Leash · Retractable Leash · Collar",
    });
    toast.success("The Walk Kit added to your bag");
  };
};

export default function BundleSection() {
  const save = (BUNDLE.compareAt - BUNDLE.price).toFixed(2);

  return (
    <section className="mx-auto max-w-[1400px] px-5 pt-16 pb-24 md:px-10 md:pt-20 md:pb-32" data-testid="bundle-section">
      <div className="grid items-center gap-12 md:grid-cols-2">
        <Reveal className="order-2 md:order-1">
          <span className="inline-block rounded-full bg-rust px-4 py-1.5 font-manrope text-xs font-bold uppercase tracking-[0.15em] text-cream">
            Save C${save}
          </span>
          <h2 className="mt-5 font-fraunces text-4xl font-light leading-tight md:text-6xl">The Walk Kit.</h2>
          <p className="mt-5 max-w-md font-manrope text-lg text-ink">{BUNDLE.short}</p>

          <ul className="mt-6 space-y-2">
            {BUNDLE.includes.map((it) => (
              <li key={it} className="flex items-center gap-3 font-manrope">
                <Check className="h-5 w-5 text-forest" strokeWidth={2} /> {it}
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <WalkKitBuilder
              trigger={
                <button
                  data-testid="add-bundle-button"
                  className="group flex items-center gap-3 rounded-full bg-rust px-8 py-4 font-manrope font-semibold text-cream transition-colors hover:bg-charcoal"
                >
                  Build the kit — {money(BUNDLE.price)} <ArrowRight className="hover-arrow h-5 w-5" />
                </button>
              }
            />
            <span className="font-manrope text-ink">
              <span className="line-through opacity-60">{money(BUNDLE.compareAt)}</span>
            </span>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="order-1 md:order-2">
          <div className="space-y-4">
            <div className="overflow-hidden bg-sand" data-testid="kit-hero-image">
              <img src={BUNDLE.hero} alt="A dog geared up for a walk in the full Kindred Mile kit" className="lifestyle-img aspect-[16/10] w-full object-cover" />
            </div>
            <div className="grid grid-cols-3 gap-4">
              {BUNDLE.images.map((im, i) => (
                <div key={i} className="overflow-hidden bg-white ring-1 ring-charcoal/10">
                  <img src={im} alt="" className="aspect-square w-full object-contain p-3" />
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
